"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const enums_1 = require("../enums");
const clientAccountByKey_1 = __importDefault(require("./clientAccountByKey"));
const clientAccounts_1 = __importDefault(require("./clientAccounts"));
const clientAccountDocuments_1 = __importDefault(require("./clientAccountDocuments"));
const portfolios_1 = __importDefault(require("./portfolios"));
const portfolioByKey_1 = __importDefault(require("./portfolioByKey"));
const portfolioPerformance_1 = __importDefault(require("./portfolioPerformance"));
const portfolioTransactions_1 = __importDefault(require("./portfolioTransactions"));
const portfolioHoldings_1 = __importDefault(require("./portfolioHoldings"));
const portfolioAssetClasses_1 = __importDefault(require("./portfolioAssetClasses"));
const FailureResponse_1 = __importDefault(require("./FailureResponse"));
const superSimplifierAccounts_1 = __importDefault(require("./superSimplifierAccounts"));
const superSimplifierAccount_1 = __importDefault(require("./superSimplifierAccount"));
const superSimplifierContributions_1 = __importDefault(require("./superSimplifierContributions"));
const superSimplifierDocuments_1 = __importDefault(require("./superSimplifierDocuments"));
const moneysoftFinancialDetails_1 = __importDefault(require("./moneysoftFinancialDetails"));
const getApiMockData = (apiName) => {
    switch (apiName) {
        case enums_1.PublicApiName.ClientAccounts:
            return clientAccounts_1.default;
        case enums_1.PublicApiName.ClientAccountByKey:
            return clientAccountByKey_1.default;
        case enums_1.PublicApiName.ClientAccountDocuments:
            return clientAccountDocuments_1.default;
        case enums_1.PublicApiName.Portfolios:
            return portfolios_1.default;
        case enums_1.PublicApiName.PortfolioByKey:
            return portfolioByKey_1.default;
        case enums_1.PublicApiName.PortfolioPerformance:
            return portfolioPerformance_1.default;
        case enums_1.PublicApiName.PortfolioTransactions:
            return portfolioTransactions_1.default;
        case enums_1.PublicApiName.PortfolioHoldings:
            return portfolioHoldings_1.default;
        case enums_1.PublicApiName.PortfolioAssetClasses:
            return portfolioAssetClasses_1.default;
        case enums_1.PublicApiName.Moneysoft:
            return moneysoftFinancialDetails_1.default;
        case enums_1.PublicApiName.SuperSimplifierAccounts:
            return superSimplifierAccounts_1.default;
        case enums_1.PublicApiName.SuperSimplifierAccount:
            return superSimplifierAccount_1.default;
        case enums_1.PublicApiName.SuperSimplifierContributions:
            return superSimplifierContributions_1.default;
        case enums_1.PublicApiName.SuperSimplifierDocuments:
            return superSimplifierDocuments_1.default;
        default:
            return FailureResponse_1.default;
    }
};
exports.default = getApiMockData;
